export default {"src":"/_next/static/media/locate.879f9f3e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};